import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  saveData(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getData(key: string): any {
    const data = sessionStorage.getItem(key);
    if (data?.length) return JSON.parse(data);
    else {
      return;
    }
  }

  clearData() {
    sessionStorage.clear();
  }
  getItem(key: string) {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    }

    setItem(key: string, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    removeItemFromLocalStorage(key: string): void {
        localStorage.removeItem(key);
    }

    clearExcept(keys: string[]) {
        const localStorageRef = { ...localStorage };
        Object.keys(localStorageRef).forEach(key => {
          if (!keys.includes(key)) {
            localStorage.removeItem(key);
            }
        });
    }
}
